export default __webpack_public_path__ + "static/media/124.89507a5d.gif";